import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode, memo } from 'react';
import { View } from 'react-native';
import {
  kBiStackedBelow,
  kBiThreeColumnsFrom,
} from '../../functions/biGridLayout';

/** A titled group of library tiles, in as many columns as fit. */
export const LibrarySection = memo(
  ({
    title,
    hint,
    empty,
    width,
    tiles,
  }: {
    title: string;
    /** A line under the title, e.g. what the section holds. */
    hint?: string;
    empty: string;
    /** The measured content width. */
    width: number;
    tiles: Array<{ key: string; node: ReactNode }>;
  }) => {
    const { rpx } = useResponsiveContext();
    const gap = rpx(12);
    const columns =
      width >= kBiThreeColumnsFrom ? 3 : width >= kBiStackedBelow ? 2 : 1;
    const tileWidth = (width - gap * (columns - 1)) / columns;
    return (
      <View style={{ gap: rpx(10) }}>
        <View style={{ gap: rpx(2) }}>
          <Typography.Text medium size={rpx(14)} color={aiColors.foreground}>
            {title}
            {tiles.length ? (
              <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
                {`  ${tiles.length}`}
              </Typography.Text>
            ) : null}
          </Typography.Text>
          {hint ? (
            <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
              {hint}
            </Typography.Text>
          ) : null}
        </View>
        {tiles.length ? (
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap }}>
            {tiles.map(tile => (
              <View key={tile.key} style={{ width: tileWidth }}>
                {tile.node}
              </View>
            ))}
          </View>
        ) : (
          <Typography.Text size={rpx(13)} color={aiColors.mutedForeground}>
            {empty}
          </Typography.Text>
        )}
      </View>
    );
  },
);
